module.exports = __webpack_public_path__ + "static/images/fa-solid-900.8310fbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.svg
// module id = zZb6
// module chunks = 12